/**
 * This file consists of helper functions that involve navigating the user from one
 * location/page in the application to another.
  */
 import { browserHistory} from 'react-router';
 import * as mixpanelTracker from 'app-lib/mixpanel/mixpanelTracker';
 import { appLogger } from 'app-lib/helpers/logging';
 import * as authInfoActions from '@getgo/webinar.com-frontend-redux/lib/web/actions/auth-info';
 import configureStore from '../../Redux/store/configureStore';

 const logger = appLogger.create('navigation helper');
 import Page from 'src/model/page';

 export function signOut() {
     mixpanelTracker.track(`${mixpanelTracker.signOutClicked}`);
     mixpanelTracker.setSuperProperties({
         aliasValue: null,
         aliasDomain: null
     });
     configureStore().dispatch(authInfoActions.logout());
 }

 export function navigateToChannel(channelKey) {
     if (!channelKey) {
         logger.error('Cannot Navigate To Channel page without a channelKey');
         return;
     }
     browserHistory.push(`/channel/${channelKey}`);
 }

 export function navigateToLearnMore() {
     mixpanelTracker.track(`${mixpanelTracker.learnMoreClicked}`);
     browserHistory.push('/organizer/learn-more');
 }

 export function navigateToWatchNow(channelKey, contentId, source, searchId = '') {
     if (!channelKey) {
         logger.error('Cannot Navigate To Watch Now without a channelKey');
         return;
     }
     if (!contentId) {
         logger.error('Cannot Navigate To Watch Now without a contentId');
         return;
     }
     let historyTarget;
     if (!(Page.values().includes(source))) {
         historyTarget = `/channel/${channelKey}/recording/${contentId}/watch?source=${Page.EXTERNAL}`;
     } else {
         historyTarget = `/channel/${channelKey}/recording/${contentId}/watch?source=${source}`;
     }
     if (searchId && searchId !== '') {
         historyTarget = `${historyTarget}&search_id=${searchId}`;
     }
     browserHistory.push(historyTarget);
 }

 export function navigateToInternalErrorPage() {
     browserHistory.push('/internalError');
 }

 export function navigateToNotFoundPage() {
     browserHistory.push('/notfound');
 }

 export function navigateToPage(url) {
     if (!url) {
         logger.error('Cannot navigate to a page without a url');
         return;
     }
     browserHistory.push(url);
 }

 export function navigateToSearchPage(query) {
     if (!query) {
         return;
     }
     browserHistory.push(`/search?q=${encodeURIComponent(query)}`);
 }



// WEBPACK FOOTER //
// ./src/app-lib/helpers/navigation-helper.js